module.exports = __webpack_public_path__ + "static/media/placeholder-institution-large.1dea20bd.png";